var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2379)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 23.385)",
    stroke: "#606f8d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.118 1v21.385",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.515 14.988-7.3971 7.3971-7.3972-7.3972",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "m29.236 16.591v5.9749c0 3.6956-2.9752 6.6707-6.6708 6.6707h-14.895c-3.6956 0-6.6708-2.9751-6.6708-6.6707v-5.9749",
    stroke: "#606F8D",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.236,
    height: 30.236,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon_upload.6fea53fc4c686f19a4b67f6fc34c469b.svg";
export { ForwardRef as ReactComponent };